export default {
  en: {
    SiteName: 'FKモバイルオーダー',
    Language: {
      Ja: '日本語',
      En: 'English'
    },
    PageTitle: {
      Index: 'FK Mobile Order',
      StoreSelect: 'Select a restaurant',
      StoreList: 'Select a restaurant',
      ReceiveMethod: 'Select one',
      MenuCategory: 'Select a category',
      MenuList: 'Select a menu',
      Coupon: 'Select a coupon',
      SetMenuList: 'Select a set menu',
      SetMenuDetail: 'Select a side',
      Cart: 'Review Your Order',
      OrderFixing: 'Finalize your order',
      TableOrderSelect: 'Select one',
      TableOrderInput: 'Enter your table number.',
      TableOrderConfirm: 'Confirm your table number.',
      PaymentMethod: 'Select your payment method.',
      InputCreditCard: 'Enter your credit card information.',
      ConfirmCreditCard: 'Enter your credit card information.',
      CompletedCreditCard: 'Enter your credit card information.',
      InputMFCard: 'Enter your My First Card information.',
      CompletedMFCard: 'Enter your My First Card information.',
      OrderProcessing: 'Your order is being processed.',
      OrderFailed: 'Your order is being processed.',
      OrderComplete: 'Your order is complete.',
      OrderHistory: 'ご注文履歴',
      UserPolicy: '利用規約',
      ErrorPage: 'Welcome to mobile order.'
    },
    Index: {
      Description: 'You can order products without waiting in line and receive them at the restaurant with ease.',
      NoticeDriveThrough: '* The product cannot be picked-up via Drive-Thru.',
      SelectLanguage: '言語を選択してください',
      SelectLanguageEn: 'Please select a language.',
      OrderStart: 'Begin ordering',
      Welocome: 'Welcome to mobile order.'
    },
    ShopSearch: {
      AreaSearch: 'Search an area.',
      CannotMFC: '* This restaurant does not accept My First Card payments.',
      Heading: 'Please select a restaurant where you wish to pick-up your products from.',
      LastUse: 'Restaurants last used',
      Note: '* Different from store business hours.',
      NotFound: 'There are no restaurants in the area selected. Please select a different area and try again.',
      NotReception: 'This restaurant is currently not accepting orders.',
      SelectAbove: 'Select an area from the above.',
      SelectArea: 'Select an area.',
      SelectReceive: 'Select a restaurant where you wish to pick-up your products.',
      StoreNotFound: 'Unable to locate a restaurant within the selected area.',
      SurroundingStore: 'Select a restaurant closest to you now.'
    },
    ReceiveMethod: {
      CanOrderMenu: 'Products you can order now.',
      ConfirmTable: 'Is this the table number you selected?',
      FixedTable: 'Confirm',
      CorrectionTable: 'Revise',
      Grand: 'Grand menu',
      InCounter: 'Pick-up at the counter (Dine-in).',
      InStore: 'Dine-in at the restaurant.',
      InStore2: 'DINE IN',
      InputTableNumber: 'Please enter your table number.',
      InTable: 'A staff will deliver your product(s) to your table (DINE IN)',
      Morning: 'Morning menu',
      OffHouse: 'Unavailable during these hours.',
      Select: 'How would you like to get your food?',
      SpecificationTable: 'Entry completed.',
      TableNumber: 'Table number',
      Takeout: 'CARRY OUT'
    },
    StoreInfo: {
      LastOrder: 'Last Order',
      Grand: 'Grand',
      Morning: 'Morning',
      OpeningTime: 'Business Hours',
      Tel: 'TEL',
      ReceptionTime: 'Mobile Order Reception Hours'
    },
    SetMenuList: {
      heading: 'Select a set menu.'
    },
    SetMenuDetail: {
      Modal: {
        Heading: 'Select from one of the following.'
      },
      PutCart: 'Add to Cart',
      Selected: 'Selecting...'
    },
    Cart: {
      Accept: 'I agree',
      AddingSelect: 'Add Order',
      Change: 'Change how to get your food',
      CouponExcluded: '* The 10% OFF coupon cannot be applied to this product.',
      DetailChange: 'Change Order',
      DeterminingOrder: 'Checkout',
      Discontinued: 'This product is currently unavailable.',
      EmailAttention: 'You will not receive an email notification when the product is ready if you do not provide an email.<BR>In this case, please do not misplace your order number generated after the payment is complete.',
      EmailAttentionDialog: 'You will not receive an email notification when the product is ready if you do not provide an email.\r\nIn this case, please do not misplace your order number generated after the payment is complete.\r\n* Please allow your device to receive emails from @wendys-firstkitchen.co.jp if there are restrictions in place.',
      EmailAttentionDialogYes: 'I understand and wish to proceed',
      EmailAttentionDialogNo: 'No - take me back',
      Heading: 'Review your order.',
      NotApplying: '* There are no products in the cart to apply the coupon.',
      OrderDetail: 'Order details',
      PrivacyTerms: [
        '* Please enter your email to receive notification regarding order completion and when your product is ready.',
        '*Table order customers will not receive an email when their products are ready.',
        'Please read our 【{privacyPolicy}】 before entering your email.',
        'If you agree to the terms of use, please place a check in the appropriate box.'
      ],
      PrivacyPolicy: 'Regarding the gain and use of personal information.',
      ReceiveMethod: 'How would you like to get your food?',
      ReceiveStore: 'Where to receive your products.',
      UseCoupon: 'Coupon content'
    },
    MenuCategory: {
      SelectMenu: 'Select a product from the menu provided.'
    },
    Coupon: {
      Attention: 'Notes',
      Common: 'Common',
      ExpirationDate: 'Duration',
      FKLimited: 'First Kitchen ONLY',
      Heading: 'Coupon',
      Nothing: 'There are no coupons available for use currently.',
      Use: 'Use coupon',
      WFKLimited: 'Wendy\'s First Kitchen ONLY'
    },
    Order: {
      Attention: {
        NotComplete: '* The order has not been processed yet.'
      },
      Cancel: 'Cancel this order',
      CompleteHeading: 'The order has been processed.',
      Failed: 'An error occurred while the order was being processed. Please show the order screen to a restaurant staff.',
      OrderNumber: 'Order Number',
      PaymentMethod: 'Payment Method',
      ProcessingHeading: 'Your order is being processed.',
      Readme: 'Please be sure to read.',
      ReadmeBody: 'Please press the "Refresh" button if you are not re-directed to a new page within 30 seconds.',
      ReceiveInfo: 'Pick-up Information',
      ToStore: 'Arrived at the Restaurant',
      PleaseWait: 'Please wait as your product is being prepared.<br>Please pick up your product when your order number appears on the pick-up monitor,<br>Please be ready to show your order number to the staff.<br>*Products will be delivered directly to customers\' tables.',
      AfterReceiving: 'Once you receive your product(s), please press the button below. You will be directed to the mobile order main page.',
      ReservedNumber: 'Reservation number',
      PaymentNumber: '決済番号',
      PaymentDate: 'Payment date and time',
      Received: 'Product(s) received.',
      ReceivedConfirmation: 'Please select "Yes" if you already received your product(s).\nOtherwise, please select "No".'
    },
    OrderHistory: {
      Head: '最新5件のご注文履歴',
      NoItem: 'ご注文履歴はございません',
      OrderDate: 'ご注文日時',
      OrderAmount: 'お支払い金額',
      ShopName: '店舗名',
      ShopAddress: '住所',
      ShowDetail: '▼注文内容確認',
      GoTop: 'トップへ戻る'
    },
    Payment: {
      AuPay: 'au PAY',
      Balance: 'Card Balance',
      CanUse: '* The following credit cards can be used.',
      Complete: 'Your payment is complete.',
      ConfirmationBalance: 'Check Remaining Balance',
      ConfirmationHeading: 'Please confirm the information.',
      CreditCard: 'Credit card',
      CreditCardHeading: 'Enter your credit card information.',
      CardNumber: 'Credit card number',
      DPay: 'D PAYMENT',
      MFCNumber: 'My First Card number',
      InputPoint: 'Please enter how many points you wish to use.',
      Method: 'Select your payment method.',
      MFCHeading: 'Enter your My First Card information.',
      MyFirstCard: 'My First Card',
      OnlineCharge: 'Online Charging',
      Pay: 'Payment',
      PayPay: 'PayPay',
      PayTotal: 'Payment Total',
      Pin: 'PIN Code',
      Point: 'Point(s)',
      RakutenPay: 'Rakuten Pay',
      SaveCard: 'Would you like to register your credit card information?\r\nIf you select 「No」, the credit card information currently registered will also be removed.',
      Select: 'Please select your payment method.',
      SecureCode: 'Security Code',
      UseDPay: 'd払いでお支払い',
      UseNew: 'Use a new credit card.',
      UsePoint: 'Use your available points.',
      UseSaved: 'Use a registered credit card.'
    },
    Dialog: {
      YesText: 'OK',
      NoText: 'No',
      OkText: 'OK'
    },
    PayPayDialog: {
      Precaution1: 'Order is not completed just by making a payment.',
      Precaution2: '',
      Precaution3: 'To complete your order, please do not close the screen after payment,',
      Precaution4: 'but wait until the Order Complete screen appears.',
      UnderstandPrecaution: 'Understand the precautions and proceed to payment.'
    },
    UserPolicy: {
      Head: '利用規約',
      Agree: '同意して始める'
    },
    General: {
      Cart: 'Cart',
      Close: 'Close',
      Change: 'Change',
      Coupon: 'Coupon',
      Delete: 'Cancel Order',
      Digits6: '(6-digits)',
      Digits16: '(16-digits)',
      Fix: 'Confirm',
      Limit: 'Date of expiration',
      Minus: 'Negative',
      Month: 'Month',
      Next: 'Next',
      NoHandling: 'Unavailable.',
      OrderHistory: 'ご注文履歴',
      Plus: 'Positive',
      Quantity: 'Count ',
      Previous: 'Next',
      PrivacyPolicy: 'Privacy Policy',
      Tokusho: '特定商取引法に基づく表記',
      Reload: 'Update',
      Return: 'Back',
      Select: 'Select',
      Send: 'Send',
      Set: 'Set',
      Single: 'A la carte',
      Tax: {
        Exclude: 'Before tax',
        Include: 'Including tax',
        None: 'Tax-free'
      },
      Top: 'Top',
      Total: 'Total',
      Year: 'Year',
      Yen: 'Yen'
    },
    AreaName: {
      kanto: 'Kanto',
      kansai: 'Kansai',
      shinetsu: 'Shinetsu',
      chubu: 'Chubu',
      kyushu: 'Kyushu'
    },
    PrefectureName: {
      tokyo: 'Tokyo',
      kanagawa: 'Kanagawa',
      saitama: 'Saitama',
      chiba: 'Chiba',
      gunma: 'Gunma',
      ibaraki: 'Ibaraki'
    },
    UserLogin: {
      AuthCode: 'Authentication code',
      AuthCodeDescription: 'An authentication code was sent to the registered email address .<br>Please enter the code provided in the email.',
      Description: 'If you log in, you will gain access to features such as list of restaurants last used and sync\'d payment methods. Login now.',
      Heading: 'For app users',
      MailAddress: 'Email address',
      Password: 'Password',
      Signin: 'Login'
    },
    Maintenance: {
      Message: 'Mobile order is unavailable because it is currently under maintenance.\nPlease place your order directly at the store.\nWe apologize for any inconveniences caused.\n(現在、メンテナンス中のためモバイルオーダーをご利用いただけません。\nご迷惑をおかけして申し訳ございませんが、店舗にてご注文をお願い致します。)',
      ButtonText: 'OK(はい)'
    },
    ErrorPage: {
      Title: 'エラーが発生いたしました',
      PleaseWait: 'しばらくしてからもう一度お試しください。',
      ErrorCode: 'エラーコード:'
    },
    ErrorMsg: {
      ERR_001: 'Your current browser does not support location services. Please use a different browser and try again.',
      ERR_002: 'Your location services feature is not enabled. Please enable this feature.',
      ERR_003: 'Unable to get your location information. Please check if you are unable to receive GPS signals or if your location services feature is disabled.',
      ERR_004: 'Timed out.',
      ERR_011: 'This order cannot be completed because it is now outside the mobile order reception hours.',
      ERR_012: 'We are no longer accepting mobile orders today as it is outside operation hours.',
      ERR_013: 'The product selected cannot be ordered because it is outside order reception hours.',
      ERR_021: 'No products have been selected. Please add products to your cart.',
      ERR_031: 'Please select an area.',
      ERR_101: 'Unable to acquire a token.',
      ERR_201: 'Rakuten Pay can be used for payments of 100 yen or more.',
      ERR_701: 'dアカウントの認証に失敗しました。',
      ERR_702: 'dアカウントの認証に失敗しました（想定外の端末）: ',
      ERR_703: 'dアカウントの認証に失敗しました（遷移元確認エラー）',
      ERR_901: 'Timed out.',
      ERR_902: 'A communication error has occurred.',
      ERR_911: 'Number of object elements exceeded.',
      ERR_999: 'An error occurred with the app. Please try again at a later time or use the online inquiry form to contact us.'
    },
    InvalidMsg: {
      ERR_001: 'Please enter your email address.',
      ERR_002: 'Please re-enter your email address. This must be within 254 letters.',
      ERR_011: 'Please enter your credit card number.',
      ERR_012: 'Please re-enter your credit card number. This is a 16-digit number.',
      ERR_021: 'Please select a month for when the credit card will expire.',
      ERR_022: 'Please re-select a valid month for when the credit card will expire.',
      ERR_023: 'Invalid order. Please try again.',
      ERR_031: 'Please select a year for when the credit card will expire.',
      ERR_032: 'Please re-select a valid year for when the credit card will expire.',
      ERR_041: 'Please enter your security code.',
      ERR_042: 'Please re-enter your security code. This is a three or four-digit number.',
      ERR_051: 'Please enter your My First Card number.',
      ERR_052: 'Please re-enter your My First Card number. This is a 16-digit number.',
      ERR_061: 'Please enter your PIN code.',
      ERR_062: 'Please re-enter your PIN code. This is a six-digit number.',
      ERR_071: 'Please enter the amount of points you wish to use.',
      ERR_072: 'Please select how many points you wish to use.',
      ERR_073: 'The point value must be more than 0.',
      ERR_074: 'We do not accept payments via points when discount services are applied (e.g. 10% OFF).',
      ERR_081: 'Please select a number.',
      ERR_082: 'Please re-select a number. This must be from 1 to 99.',
      ERR_091: 'Please enter your password.',
      ERR_101: 'Please enter your table number.',
      ERR_102: 'Please re-enter your table number. This is a three-digit number.',
      ERR_111: 'Please enter your authentication code.'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/lang/TranslationsEN.js